import { SigninSilentArgs } from 'oidc-client-ts';
import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';

import { lockForTokenRefresh, releaseLockForTokenRefresh } from '../utils';

let isDoingSilentReAuth = false;

export function useSigninSilentWithLock() {
  const { signinSilent } = useAuth();

  return useCallback(
    async (args?: SigninSilentArgs) => {
      // Prevent multiple call
      if (isDoingSilentReAuth) {
        return;
      }
      try {
        isDoingSilentReAuth = true;
        await lockForTokenRefresh();
        const user = await signinSilent(args);
        if (!user) {
          throw new Error('User not found.');
        }
        await releaseLockForTokenRefresh();
        return user;
      } finally {
        isDoingSilentReAuth = false;
      }
    },
    [signinSilent]
  );
}
